// OrgConsole default dev environment.
// NOTE: For spoke deployments, firebaseConfig.projectId is patched by
// provision-org-spoke.sh to point to the org's Firebase project.

export const environment = {
  production: false,
  appCheckDebugToken: 'REPLACE_WITH_DEBUG_TOKEN',
  recaptchaSiteKey: '6LepGeksAAAAABejU9wnT3MmH0w56mcjXwmLcnk5',
  firebaseConfig: {
    apiKey: "AIzaSyAsoBqyBDiSyIt3zCnYav_xfIqhVse4l1o",
    authDomain: "ch-d-testcommunity-bgl6.firebaseapp.com",
    projectId: "ch-d-testcommunity-bgl6",
    storageBucket: "ch-d-testcommunity-bgl6.firebasestorage.app",
    messagingSenderId: "141232846126",
    appId: "1:141232846126:web:60cddab922cb3f3a77f6bf",
  },
  stripeKey: "pk_test_51LsogEEQkKnpYqBZiG4X70WG2WnI94TzKZNrBWLfTU0o5hrFpPZEUOf39VioWABFeB0Y8nD6YZd6pEH9aVsbp60X005oYTEVbS",
  appUrls: {
    onboard: "https://onboard-dev.chareety.com",
    partners: "https://partners-dev.chareety.com",
    myChareety: "https://my-dev.chareety.com",
    marketing: "https://dev.chareety.com",
  },
};
